import {Component, OnInit, ViewEncapsulation} from '@angular/core';

export interface PersonalInformation {
    firstName:string;
    lastName:string;
    school: School;
    email:string;
    description:string;
    phoneNumber:string;
}

export interface School {
    nameOfSchool: string;
    program: string;
}

export interface SocialInfo {
    iconClassInfo:string;
    url:string;
}

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AboutComponent implements OnInit {

    public personalInfo:PersonalInformation = {
        firstName: "Leo Jr",
        lastName: "Silao",
        school: {
            nameOfSchool: "Concordia University",
            program: "Software engineering program"
        },
        email: "leojrsilao@gmail.com",
        description: "I started programming in 2013, where I learned Java in full deph, and the core fundementals to create e-commerce websites alternatively using ASP.NET, JSP.NET, and PHP. I learned the basics of creating HTML pages, CSS and framesworks such as bootstrap to help design websites faster and easier. I love learning new front-end technologies such as Angular, React and Vue. I've built a react appplication to automate business needs with the use of Node.JS. I am experienced in adapting and creating applications with the use of agile frameworks to provide highly functional websites. ",
        phoneNumber: "(514) 513-2068"
    };

    public socialData:SocialInfo[] = [
        {
            iconClassInfo: "fa fa-linkedin fa-stack-1x fa-inverse",
            url: "https://ca.linkedin.com/in/leo-jr-silao-62083a76"
        },
        {
            iconClassInfo: "fa fa-github fa-stack-1x fa-inverse",
            url: "https://github.com/leojrsilao"
        }
    ];

    constructor() {
    }

    ngOnInit() {
    }

}
